import api from '../utils/api';
import { Lead } from '../types/Lead';

// Get all leads
export const getLeads = async (): Promise<Lead[]> => {
  try {
    
    const response = await api.get('leads');
    
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Get a single lead by id (used by notification deep-links)
export const getLead = async (id: string): Promise<Lead> => {
  const response = await api.get(`leads/${id}`);
  return response.data;
};

// Create new lead
export const createLead = async (leadData: Partial<Lead>): Promise<Lead> => {
  try {
    
    const response = await api.post('leads', leadData);
    
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Mark lead as dead
export const markLeadAsDead = async ({ leadId, dropReason }: { leadId: string; dropReason: string }): Promise<Lead> => {
  try {
    
    const response = await api.put(`leads/${leadId}/mark-dead`, { dropReason });
    
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Update lead
export const updateLead = async (leadId: string, leadData: Partial<Lead>): Promise<Lead> => {
  try {
    
    const response = await api.put(`leads/${leadId}`, leadData);
    
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Convert lead to client
export const convertLeadToClient = async (leadId: string, clientData: any): Promise<Lead> => {
  try {
    
    const response = await api.post(`leads/${leadId}/convert`, clientData);
    
    return response.data;
  } catch (error) {
    
    throw error;
  }
};
